import moment from "moment";
import {
  datePattern,
  fnTextBookingAmount,
  fnTextFirstIsRetained,
  fnTextNonRefundableRate,
  fnTextWithoutPenalty,
  shortDateDayYYYY,
  textFirstIsRetained,
  textNonRefundableRate,
} from "./dataHelperCancellation";

const parsCancellationPolicy = (content) => {
  let arrayContent = [];

  const startdateFN = (date_in, term, pattern) => {
    return moment(date_in).subtract(Number(term), "days").format(pattern);
  };

  // const startdateAll = (date_in, term, patternAll) => {
  //   return moment(date_in).subtract(Number(term), "days").format(patternAll);
  // };

  const checkCountingType = (
    elem,
    content,
    patternFN,
    patternAll,
    patternOrderDate
  ) => {
    const contentCountingType = {};
    if (elem?.countingType === "2") {
      contentCountingType.valueWithoutPenaltyShort = startdateFN(
        elem?.fixDate,
        elem?.term,
        patternFN
      );
      contentCountingType.valueWithoutPenalty = startdateFN(
        elem?.fixDate,
        elem?.term,
        patternAll
      );
      contentCountingType.orderDate = startdateFN(
        elem?.fixDate,
        elem?.term,
        patternOrderDate
      );
      return contentCountingType;
    } else {
      contentCountingType.valueWithoutPenaltyShort = startdateFN(
        content?.date_in,
        elem?.term,
        patternFN
      );
      contentCountingType.valueWithoutPenalty = startdateFN(
        content?.date_in,
        elem?.term,
        patternAll
      );
      contentCountingType.orderDate = startdateFN(
        content?.date_in,
        elem?.term,
        patternOrderDate
      );
      return contentCountingType;
    }
  };

  const checkDateFn = (arrayPeriods, date_in) => {
    let status = false;
    if (arrayPeriods.length === 0) {
      return false;
    }
    for (var i = 0; i < arrayPeriods.length; i++) {
      const checkIsOper = checkIsBetween(
        date_in,
        arrayPeriods[i]?.start,
        arrayPeriods[i]?.end
      );
      if (checkIsOper) {
        status = true;
        break;
      }
    }
    return status;
  };

  const checkIsBetween = (date_in, start, end) => {
    let start_date = moment(start).format(datePattern);
    let end_date = moment(end).format(datePattern);
    let result = moment(date_in).isBetween(start_date, end_date, null, "[]");
    return result;
  };

  const switchCehckDate = (elem, content) => {
    let checkIsOperVal = false;
    checkIsOperVal = checkDateFn(elem?.periods, content?.date_in);
    return checkIsOperVal;
  };

  const outsideThePeriod = (valueWithoutPenalty) => {
    return moment().isSameOrAfter(valueWithoutPenalty, "day");
  };

  const nonRefundableRate = (elem) => {
    const checkIsOper = switchCehckDate(elem, content);
    if (checkIsOper === false) {
      return;
    }
    const contentCountingType = checkCountingType(
      elem,
      content,
      shortDateDayYYYY,
      datePattern,
      datePattern
    );
    let valPush = fnTextNonRefundableRate(
      contentCountingType?.valueWithoutPenaltyShort,
      textNonRefundableRate
    );

    arrayContent.push({
      content: valPush,
      color: 3,
      valueWithoutPenalty: contentCountingType?.valueWithoutPenalty,
      orderDate: contentCountingType?.orderDate,
    });
  };

  const percentPrice = (total, percent) => {
    const textPercentPrice = (total * Number(percent)) / 100;
    return textPercentPrice;
  };

  const bookingAmount = (elem) => {
    const checkIsOper = switchCehckDate(elem, content);
    if (checkIsOper === false) {
      return;
    }
    const contentCountingType = checkCountingType(
      elem,
      content,
      shortDateDayYYYY,
      datePattern,
      datePattern
    );

    const checkPriceVal = () => {
      if (
        content?.rate?.total_discount?.price &&
        content?.rate?.total_discount?.price !== 0
      ) {
        return content?.rate?.total_discount?.price;
      }
      return content?.rate?.price;
    };

    let valPush = fnTextBookingAmount(
      contentCountingType?.valueWithoutPenaltyShort,
      percentPrice(checkPriceVal(), elem?.percent)
    );
    arrayContent.push({
      content: valPush,
      color: 2,
      valueWithoutPenalty: contentCountingType?.valueWithoutPenalty,
      orderDate: contentCountingType?.orderDate,
    });
  };

  const withoutPenalty = (elem) => {
    const checkIsOper = switchCehckDate(elem, content);
    if (checkIsOper === false) {
      return;
    }
    const contentCountingType = checkCountingType(
      elem,
      content,
      shortDateDayYYYY,
      shortDateDayYYYY,
      datePattern
    );

    let valPush = fnTextWithoutPenalty(
      contentCountingType?.valueWithoutPenaltyShort
    );
    arrayContent.push({
      content: valPush,
      color: 0,
      valueWithoutPenalty: contentCountingType?.valueWithoutPenalty,
      orderDate: contentCountingType?.orderDate,
    });
  };

  const firstIsRetained = (elem) => {
    const checkIsOper = switchCehckDate(elem, content);
    if (checkIsOper === false) {
      return;
    }
    const contentCountingType = checkCountingType(
      elem,
      content,
      shortDateDayYYYY,
      datePattern,
      datePattern
    );
    let valPush = fnTextFirstIsRetained(
      contentCountingType?.valueWithoutPenaltyShort,
      textFirstIsRetained
    );
    arrayContent.push({
      content: valPush,
      color: 1,
      valueWithoutPenalty: contentCountingType?.valueWithoutPenalty,
      orderDate: contentCountingType?.orderDate,
    });
  };

  const sortDateArray = (arrayContent) => {
    let newDateArrayContent = [];
    let returnDateArray = [];

    function sortDate(dateA, dateB, direction = "asc") {
      const formats = datePattern;
      return (
        (moment(dateA, formats).isBefore(moment(dateB, formats))
          ? -1
          : moment(dateA, formats).isAfter(moment(dateB, formats))
            ? 1
            : 0) * (direction === "asc" ? 1 : -1)
      );
    }
    newDateArrayContent = arrayContent.sort((a, b) =>
      sortDate(a.orderDate, b.orderDate)
    );

    let valueIndexSlice = 0;
    for (var i = 0; i < newDateArrayContent.length; i++) {
      if (outsideThePeriod(arrayContent[i].orderDate) === false) {
        if (i === 0 || i === 1) {
          returnDateArray = arrayContent;
          break;
        }
        valueIndexSlice = i - 1;
        break;
      } else {
        if (i + 1 === newDateArrayContent.length) {
          returnDateArray.push(newDateArrayContent[i]);
          break;
        }
      }
    }

    if (valueIndexSlice === 0) {
    } else {
      returnDateArray = newDateArrayContent.toSpliced(0, valueIndexSlice);
    }
    return returnDateArray;
  };

  const withoutPenaltyTextParams = (arrayContent) => {
    const checkFreePayment = arrayContent.filter((elem) => elem?.color === 0);
    if (checkFreePayment.length === 0 || arrayContent.length <= 1) {
      return arrayContent;
    }

    let newDateArrayContent = [];
    const withoutFreePayment = arrayContent.filter((elem) => elem?.color !== 0);
    var arrayContentDate = withoutFreePayment.map(function (elem) {
      return moment(elem.valueWithoutPenalty, datePattern);
    });
    const dateСancellationСonditions = moment
      .min(arrayContentDate)
      .format(shortDateDayYYYY);

    arrayContent.forEach((element) => {
      if (element?.color === 0) {
        let shortI = Object.assign({}, element);
        shortI.valueWithoutPenalty = dateСancellationСonditions;
        newDateArrayContent.push(shortI);
      } else {
        newDateArrayContent.push(element);
      }
    });
    return newDateArrayContent;
  };

  const switchFnCancellationPolicy = (elem) => {
    switch (elem?.fine) {
      case "4":
        return nonRefundableRate(elem);
      case "3":
        return bookingAmount(elem);
      case "2":
        return firstIsRetained(elem);
      case "1":
        return withoutPenalty(elem);
    }
  };
  content?.rate?.cancellation_policy?.conditions.forEach((element) => {
    switchFnCancellationPolicy(element);
  });
  if (arrayContent.length === 0) {
    return null;
  }
  arrayContent = sortDateArray(arrayContent);

  return arrayContent;
};

const checkFreeCancellation = (elem) => {
  return elem.some((entry) => entry?.color === 0);
};

const checkDoesNotReturn = (elem) => {
  let arrayCheck = [1, 2];
  return elem.some((entry) => arrayCheck.includes(entry?.color));
};

const checkNonRefundableRate = (elem) => {
  const checkaVal = elem.some((entry) => entry.color === 3);
  if (elem.length === 1 && checkaVal) {
    return true;
  }
  return false;
};

const fnSwitchDateFreeCancellation = (arrayCancellationPolicy) => {
  const valDate = arrayCancellationPolicy.filter((entry) => entry?.color === 0);
  return valDate[0]?.valueWithoutPenalty;
};

export {
  parsCancellationPolicy,
  checkFreeCancellation,
  checkDoesNotReturn,
  checkNonRefundableRate,
  fnSwitchDateFreeCancellation,
};
